<template>
    <div class="min-h-screen md:h-auto px-0 lg:px-24 container overflow-y-hidden relative" style="padding-bottom: 0px">
      <div>
        <FormPage 
          name="proposal"/>
      </div>
    </div>
  </template>
  
  <script>
  import FormPage from "@/components/general/FormPage";
  import form from "@/assets/ts/proposal/base";
  import { defineComponent, onBeforeMount, onMounted, ref, nextTick } from "vue";
  import store from "@/store";
  import { useRouter } from "vue-router";
  
  import getSDG from "@/assets/ts/proposal/steps/sdg";
  import getGoals from "@/assets/ts/proposal/steps/goals";
  import getOrg from "@/assets/ts/proposal/steps/organization";
  
  export default defineComponent({
    components: {
      FormPage,
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        store.dispatch('setForm', form)
      });
    },
  
    setup(){
      const router = useRouter()
  
     function getForm() {
        return {
          goals: getGoals(),
          sdg: getSDG(),
          organization: getOrg(),
        }
      }
  
      function handleChangeLang() {
        nextTick(() => {
          store.dispatch('setForm', {
            goals: getGoals(),
            sdg: getSDG(),
            organization: getOrg(),
          })
        })
      }
      
      onBeforeMount(() =>{
        if(!('two_fiscal_years' in store.state.general.formData))
          router.push('/proposal')
        store.dispatch('setForm', getForm())
      })
  
      return  { handleChangeLang, getForm }
    }
  })
  
  </script>
  